<div class="ai-data-model-response-renderer"
     *ngIf="isValidResponse()">
  <div class="ai-preview">
    <!-- Header -->
    <div class="ai-header"
         *ngIf="getHeaderTitle()">
      <h3 class="ai-title">{{ getHeaderTitle() }}</h3>
    </div>

    <!-- Content -->
    <div class="ai-content">
      <!-- Case 1: Only Data Models -->
      <div *ngIf="hasModels() && !hasRelations()">
        <div *ngFor="let content of getModels()"
             class="ai-model-section">
          <div class="ai-model-header">
            <h4 class="ai-model-title">{{ getDisplayName(content) }}</h4>
            <div class="ai-model-description">
              {{ getDescription(content) }}
            </div>
          </div>

          <div class="ai-model-content">
            <!-- Data Model Section -->
            <div class="ai-model-data-section">
              <div class="data-model-header">
                <h5 class="data-model-title">
                  <i class="fa-solid fa-database"></i>
                  Data Model
                </h5>
              </div>
              <div class="data-model-content">
                <rappider-list-grid [config]="listGridConfig"
                                    [data]="getDataModelFields(content)"
                                    [loading]="false">
                </rappider-list-grid>
              </div>
            </div>

            <!-- Info Message -->
            <rappider-alert class="description-alert"
                            [type]="AlertTypes.Info"
                            [description]="{text: 'To ensure proper auditing, every data table will automatically include default fields to track its history, such as id, created/updated/deleted information, and an isDeleted flag.'}"
                            [showIcon]="true"
                            [closeable]="false">
            </rappider-alert>

            <!-- Save Button -->
            <div *ngIf="showActions"
                 class="ai-model-action-button">
              <button class="create-data-model-button"
                      [class.loading]="isSaving"
                      [disabled]="isSaving || !activeProjectId || isModelCreated(content)"
                      (click)="onSaveClick(content)">
                <img src="/assets/icons/regular-database-circle-plus-full.svg"
                     alt="Create Content"
                     class="button-icon">
                <span class="button-text">
                  {{ isSaving ? 'Creating...' : (isModelCreated(content) ? 'Created Successfully' : getButtonText(content)) }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Case 2: Only Relations -->
      <div *ngIf="!hasModels() && hasRelations()"
           class="ai-model-section">
        <div class="ai-model-header">
          <h4 class="ai-model-title">Relations</h4>
          <div class="ai-model-description">
            Generated relations between data models
          </div>
        </div>

        <div class="ai-model-content">
          <!-- Relations Section -->
          <div class="ai-model-relations">
            <div class="relations-header">
              <h5 class="relations-title">
                <i class="fa-solid fa-link"></i>
                Relations
              </h5>
            </div>
            <div class="relations-content">
              <rappider-list-grid [config]="relationsListGridConfig"
                                  [data]="getAllFormattedRelations()"
                                  [loading]="false">
              </rappider-list-grid>
            </div>
          </div>

          <!-- Missing Models Alert -->
          <div class="missing-models-alert">
          <rappider-alert *ngIf="hasMissingModelsForRelations()"
                          [type]="hasAttemptedSave ? AlertTypes.Error : AlertTypes.Warning"
                          [description]="{text: getMissingModelsMessage()}"
                          [showIcon]="true"
                          [closeable]="false">
          </rappider-alert>
          </div>
          <!-- Save Button -->
          <div *ngIf="showActions"
               class="ai-model-action-button">
            <button class="create-data-model-button"
                    [class.loading]="isSaving"
                    [disabled]="isSaving || !activeProjectId || areRelationsCreated"
                    (click)="onSaveClick(null)">
              <img src="/assets/icons/regular-database-circle-plus-full.svg"
                   alt="Create Content"
                   class="button-icon">
              <span class="button-text">
                {{ isSaving ? 'Creating...' : (areRelationsCreated ? 'Created Successfully' : getButtonText(null)) }}
              </span>
            </button>
          </div>
        </div>
      </div>

      <!-- Case 3: Both Data Models and Relations -->
      <div *ngIf="hasModels() && hasRelations()">
        <div *ngFor="let content of getModels()"
             class="ai-model-section">
          <div class="ai-model-header">
            <h4 class="ai-model-title">{{ getDisplayName(content) }}</h4>
            <div class="ai-model-description">
              {{ getDescription(content) }}
            </div>
          </div>

          <div class="ai-model-content">
            <!-- Data Model Section -->
            <div class="ai-model-data-section">
              <div class="data-model-header">
                <h5 class="data-model-title">
                  <i class="fa-solid fa-database"></i>
                  Data Model
                </h5>
              </div>
              <div class="data-model-content">
                <rappider-list-grid [config]="listGridConfig"
                                    [data]="getDataModelFields(content)"
                                    [loading]="false">
                </rappider-list-grid>
              </div>
            </div>

            <!-- Relations Section -->
            <div *ngIf="getFormattedRelationsForModel(getDisplayName(content)).length > 0"
                 class="ai-model-relations">
              <div class="relations-header">
                <h5 class="relations-title">
                  <i class="fa-solid fa-link"></i>
                  Relations
                </h5>
              </div>
              <div class="relations-content">
                <rappider-list-grid [config]="relationsListGridConfig"
                                    [data]="getFormattedRelationsForModel(getDisplayName(content))"
                                    [loading]="false">
                </rappider-list-grid>
              </div>
            </div>

            <!-- Info Message -->
            <rappider-alert class="description-alert"
                            [type]="AlertTypes.Info"
                            [description]="{text: 'To ensure proper auditing, every data table will automatically include default fields to track its history, such as id, created/updated/deleted information, and an isDeleted flag.'}"
                            [showIcon]="true"
                            [closeable]="false">
            </rappider-alert>

            <!-- Missing Models Alert -->
            <div class="missing-models-alert">
            <rappider-alert *ngIf="hasMissingModelsForRelations()"
                            [type]="hasAttemptedSave ? AlertTypes.Error : AlertTypes.Warning"
                            [description]="{text: getMissingModelsMessage()}"
                            [showIcon]="true"
                            [closeable]="false">
            </rappider-alert>
            </div>
            <!-- Save Button -->
            <div *ngIf="showActions"
                 class="ai-model-action-button">
              <button class="create-data-model-button"
                      [class.loading]="isSaving"
                      [disabled]="isSaving || !activeProjectId || isModelCreated(content)"
                      (click)="onSaveClick(content)">
                <img src="/assets/icons/regular-database-circle-plus-full.svg"
                     alt="Create Content"
                     class="button-icon">
                <span class="button-text">
                  {{ isSaving ? 'Creating...' : (isModelCreated(content) ? 'Created Successfully' : getButtonText(content)) }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Case 4: Only Actions (Updated Model Display) -->
      <div *ngIf="!hasModels() && !hasRelations() && hasActions()"
           class="ai-model-section">
        <!-- Loading State -->
        <div *ngIf="isUpdatingModel"
             class="ai-model-loading">
          <nz-spin [nzSize]="'large'">
          </nz-spin>
        </div>

        <!-- No Changes Display -->
        <div *ngIf="currentProjectModel && !isUpdatingModel && hasNoChanges()">
          <div class="ai-model-header">
            <h4 class="ai-model-title">{{ currentProjectModel.name }}</h4>
            <div class="ai-model-description">
              {{ currentProjectModel.description }}
            </div>
          </div>

          <div class="ai-model-content">
            <!-- No Changes Info Message -->
            <rappider-alert class="description-alert"
                            [type]="AlertTypes.Info"
                            [description]="{text: getNoChangesMessage()}"
                            [showIcon]="true"
                            [closeable]="false">
            </rappider-alert>
          </div>
        </div>

        <!-- Model Display with Changes -->
        <div *ngIf="currentProjectModel && !isUpdatingModel && !hasNoChanges()">
          <div class="ai-model-header">
            <h4 class="ai-model-title">{{ currentProjectModel.name }}</h4>
            <div class="ai-model-description">
              {{ currentProjectModel.description }}
            </div>
          </div>

          <div class="ai-model-content">
            <!-- Current Data Model Section -->
            <div class="ai-model-data-section">
              <div class="data-model-header">
                <h5 class="data-model-title">
                  <i class="fa-solid fa-database"></i>
                  Updated {{ currentProjectModel.dataTableName }} Data Model
                </h5>
              </div>
              <div class="data-model-content">
                <rappider-list-grid [config]="currentModelListGridConfig"
                                    [data]="getCurrentModelFields()"
                                    [loading]="false">
                </rappider-list-grid>
              </div>
            </div>

            <!-- Color Legend Info -->
            <div class="color-legend-simple">
              <div class="legend-row">
                <div class="legend-color new-field"></div>
                <span class="legend-text">New Field</span>
              </div>
              <div class="legend-row">
                <div class="legend-color deleted-field"></div>
                <span class="legend-text">Deleted Field</span>
              </div>
            </div>

            <!-- Info Message -->
            <rappider-alert class="description-alert"
                            [type]="AlertTypes.Info"
                            [description]="{text: getActionMessage()}"
                            [showIcon]="true"
                            [closeable]="false">
            </rappider-alert>

            <!-- Update Button -->
            <div class="ai-model-action-button">
              <button class="create-data-model-button"
                      [class.loading]="isSaving"
                      [disabled]="isSaving || isModelUpdatedSuccessfully"
                      (click)="onUpdateModelClick()">
                <img src="/assets/icons/regular-database-circle-plus-full.svg"
                     alt="Update Model"
                     class="button-icon">
                <span class="button-text">
                  {{ isSaving ? 'Updating...' : (isModelUpdatedSuccessfully ? 'Updated Successfully' : 'Update ' + currentProjectModel.dataTableName + ' Data Model') }}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
